module.exports = __webpack_public_path__ + "img/finish.129d381b.png";